// extracted by mini-css-extract-plugin
export default {"section-history-modal":"SectionHistoryModal_section-history-modal__3fgNA","header-wrapper":"SectionHistoryModal_header-wrapper__jbH-+","content":"SectionHistoryModal_content__vyGGR"};